import React, { ReactNode, useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setSavedRoute } from "../../slices/shared";

interface Props {
  loadApp: () => Promise<void>;
  children: ReactNode;
}

const AmplifyAuth: React.FC<Props> = (props) => {
  const { loadApp, children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  useEffect(() => {
    const match = location.pathname.match(/^\/app\/(.+)$/);
    if (match) {
      const sliced = match.slice(1).join("/");
      dispatch(setSavedRoute(sliced || undefined));
    }
  }, [authStatus, location.pathname, dispatch]);

  useEffect(() => {
    if (authStatus === "authenticated") {
      const stored = sessionStorage.getItem("savedRoute");
      if (stored) {
        dispatch(setSavedRoute(stored));
      }
    }
  }, [authStatus, dispatch]);

  useEffect(() => {
    if (authStatus === "authenticated") {
      loadApp();
    } else if (authStatus === "unauthenticated") {
      window.location.href = `${process.env.REACT_APP_AUTH_URL}/app/gmd`;
    }
  }, [authStatus, loadApp, navigate]);

  return <>{authStatus === "authenticated" ? children : <></>}</>;
};

export default AmplifyAuth;
